// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1G51j","name":"ConsentHeader_name__3Rqfb","birthday":"ConsentHeader_birthday__2QcGx","skeleton":"ConsentHeader_skeleton__10Wdt"};